import React, { Component } from 'react';
import { Button, Menu, Image, Responsive,
  Visibility } from 'semantic-ui-react';

const logo=require('../img/logo.svg');

class NavbarMobile extends Component {
  state = {}

  hideFixedMenu = () => this.setState({ fixed: false })
  showFixedMenu = () => this.setState({ fixed: true })

  render() {
    const { fixed } = this.state
    return (
      <Visibility once={false} onBottomPassed={this.showFixedMenu} onBottomPassedReverse={this.hideFixedMenu}>
        <Responsive {...Responsive.onlyMobile}>
          <Menu
            fixed={fixed ? 'top' : null}
            secondary={!fixed}
            borderless
            >
             <Image href='/home' src={logo} size='small' style={{padding: '1em 1em'}}/>
            <Menu.Item position='right'>
              <Button as='a' compact href='/about' size='tiny'>About</Button>
              <Button color='pink' as='a' compact href='/home#request-acesss' size='tiny' style={{ marginLeft: '0.5em' }}>Request Access</Button>
            </Menu.Item>
          </Menu>
        </Responsive>
      </Visibility>
    )
  }
};

export default NavbarMobile;



// WEBPACK FOOTER //
// ./src/js/NavbarMobile.js